import { Directive, ElementRef, OnInit } from '@angular/core';
import { DomListenerFactoryService } from 'src/app/services/dom-listener-factory.service';
import { CustomerSupportService } from 'src/app/services/customer-support.service';
@Directive({
  selector: '[appCustomHelpRedirection]',
  standalone: true,
})
export class CustomHelpRedirectionDirective implements OnInit {
  constructor(
    private elementRef: ElementRef,
    private domListenerFactoryService: DomListenerFactoryService,
    private customerSupportService: CustomerSupportService,
  ) {}

  ngOnInit() {
    this.domListenerFactoryService
      .createInstance()
      .add(this.elementRef.nativeElement, 'click', (event: Event) => {
        if (this.customerSupportService.customSupportEnabled) {
          event.preventDefault();
          event.stopPropagation();
          this.customerSupportService.openLink();
        }
      });
  }
}
